// ST環境設定
export const environment = {
  // --------------------------------------------------
  // 1. 各子工程が独自に所有する業務用のプロパティ
  // --------------------------------------------------
  production: false,
  bffUrl: 'https://sap-api.app.daiichilife.dev/bff-st01', // プロキシ経由のため相対パス
  apiVersion: 'v1',

  // --------------------------------------------------
  // 2. 共通通信部品（common-lib）の動作に必要な共通環境変数項目
  // --------------------------------------------------
  /** 社外アクセス判定フラグ（true: 社内、false: 社外） */
  isInternal: false,
  /** トークン取得エンドポイントURL */
  authUrl: '',
  /** トークンの自動再発行（refresh）URL */
  authRefreshUrl: '',
  /** 通信コンポーネント全体のデフォルトタイムアウト時間（120秒 = 120000ms） */
  constTimeout: 120000,
  /** トークン取得処理時の専用タイムアウト時間（120秒 = 120000ms） */
  apiRequestUrlTimeout: 120000,
  /** 送信ヘッダーに自動マッピングされるCSRFヘッダー値（デフォルト固定値） */
  csrfHeader: 'DLCPF',
  /** 社内・社外による認証処理の呼び出しフラグ */
  skipAuth: true,
  /** 社外/社内アクセス用の認証APIを有効化するかどうかのフラグ（false: 無効 ダミートークンを使用、true: 有効） */
  authApiEnabled: false,
  /** ダミートークン */
  dummyToken: '8f0b3e1a24dc29e6c48577bc049b69e4',
};
